<script setup lang="ts">
interface Props {
  progress: number;
  potentialProgress?: number;
}

const props = withDefaults(defineProps<Props>(), {
  potentialProgress: 0
});
</script>

<template>
  <div class="ui-progress-line">
    <progress class="ui-progress-line__tag" :value="props.progress" max="100">
      {{ props.progress }}
    </progress>
  </div>
</template>

<style scoped>
.ui-progress-line {
  position: relative;
  width: 100%;
  height: 6px;
  overflow: hidden;
  background-color: var(--color-secondary-contrast);
  border-radius: 3px;
}

.ui-progress-line::before,
.ui-progress-line::after {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: var(--color-green);
  border-radius: 3px;
  transition: width var(--animation-medium) var(--animation-effect);
  content: '';
}

.ui-progress-line::before {
  width: v-bind(progress + '%');
}

.ui-progress-line::after {
  width: v-bind(potentialProgress + '%');
  opacity: 0.25;
}

.ui-progress-line__tag {
  opacity: 0;
}
</style>
